import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MessageText\UpdateMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/UpdateMessageTextController.php
* @route '/api/message-text/{message_text}'
*/
const UpdateMessageTextController = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateMessageTextController.url(args, options),
    method: 'put',
})

UpdateMessageTextController.definition = {
    methods: ["put"],
    url: '/api/message-text/{message_text}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\MessageText\UpdateMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/UpdateMessageTextController.php
* @route '/api/message-text/{message_text}'
*/
UpdateMessageTextController.url = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { message_text: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { message_text: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            message_text: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        message_text: typeof args.message_text === 'object'
        ? args.message_text.id
        : args.message_text,
    }

    return UpdateMessageTextController.definition.url
            .replace('{message_text}', parsedArgs.message_text.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\UpdateMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/UpdateMessageTextController.php
* @route '/api/message-text/{message_text}'
*/
UpdateMessageTextController.put = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateMessageTextController.url(args, options),
    method: 'put',
})

export default UpdateMessageTextController